import { FilterOption } from '@/models/gen/graphql';
import { ReactElement } from 'react';
import Select from '@/common/Select';
import { getStates } from '@/api/services/filters/states';

export const generateOptions = (
  list: Array<Record<string, string>> | FilterOption[],
  valueKey = 'id',
  labelKey = 'displayName'
): ReactElement[] =>
  (list || []).map(
    (item: Record<string, string> | FilterOption): ReactElement => (
      <Select.Option key={item[valueKey]} value={item[valueKey]}>
        {item[labelKey]}
      </Select.Option>
    )
  );

export const getStatesOptions = async (): Promise<ReactElement[]> => {
  const res = await getStates();
  return generateOptions(res);
};

export const getCountryOptions = async (): Promise<ReactElement[]> => {
  // Placeholder for future country options query
  const res = [{ id: 'USA', displayName: 'United States' }];
  return generateOptions(res);
};
